/* istanbul ignore file */

import { createElement } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'

/**
 * This is a shared function applications can use to generate one-off DOM elements
 * to be included in a HTTP HTML response outside the context of a React application.
 *
 * NOTE: We really should just find a way to do this inside foundation without a dependency on React.
 * This involves a lot of indirection that just isn't needed for what this is used for, which is for creating simple
 * script and link tags with no children.
 */
const staticElementCreator = (htmlElement, tagProps) => {
  const el = createElement(htmlElement, tagProps)
  return renderToStaticMarkup(el)
}

export default staticElementCreator
